import { SaneImage } from 'components';
import { ReactNode } from 'react';

interface SmallQuoteProps {
  quote: ReactNode;
  image: string;
  name: string;
  title: string;
}

export function SmallQuote({ quote, image, name, title }: SmallQuoteProps) {
  return (
    <div className="px-4 py-10 sm:px-8 lg:px-8">
      <blockquote className="mx-auto max-w-3xl font-medium">
        <p className="text-center text-lg sm:text-xl md:text-2xl md:leading-9">
          &ldquo;{quote}&rdquo;
        </p>
        <div className="mt-4 flex flex-row items-center justify-center md:mt-8">
          <div className="mr-4 h-10 w-10 overflow-hidden rounded-full">
            <SaneImage src={image} />
          </div>

          <div className="md:flex md:items-center md:justify-center">
            <div className="text-gray-900">{name}</div>

            <svg
              className="mx-1 hidden h-5 w-5 text-indigo-600 md:block"
              fill="currentColor"
              viewBox="0 0 20 20"
            >
              <path d="M11 0h3L9 20H6l5-20z" />
            </svg>

            <div className="text-gray-500">{title}</div>
          </div>
        </div>
      </blockquote>
    </div>
  );
}
